<button
  type="button"
  [class]="{ 'small-icon-button': small() }"
  mat-icon-button
  [cdkCopyToClipboard]="content() ?? ''"
  [disabled]="!content()"
  (cdkCopyToClipboardCopied)="copied($event)"
  matTooltip="In Zwischenablage kopieren"
  #btn
>
  @if (copyDone()) {
    <mat-icon>check</mat-icon>
  } @else {
    <mat-icon>{{ icon() }}</mat-icon>
  }
</button>
